import { createVanIconComponent } from "./van"

const Aim = createVanIconComponent("aim")
export default Aim
